import React from "react";
import { currencyFormatNoDecimals, AppliesToFriendlyNames } from "../../shared/shared";
import {INCOME_TYPES} from "../../shared/constants";

export const Incomes = (props) => {
    const financialDataItemTHStyle = {
        padding: "0.5em"
    };
    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemTRStyle = {
        borderBottom: "1p solid #ccc"
    }
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }
    const displayIncomeTypeLabel = (dataItem) => {
        const options = INCOME_TYPES.map(item => {
            let label = item.text;
            if (item.value === "OTHER" && dataItem.incomeTypeOtherName) {
                label = dataItem.incomeTypeOtherName;
            }
            return {
                ...item,
                text: label,
            }
        });
        const selectedOption = options.find((c) => c.value === dataItem.incomeType);
        return selectedOption.text;
    };

    return (<div>
        <h2 style={subSectionStyle}> Incomes</h2>
        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#157ee8",
                    color: "white",
                }}>
                    <th style={financialDataItemTHStyle}>Income Type</th>
                    <th style={financialDataItemTHStyle}>Frequency</th>
                    <th style={financialDataItemTHStyle}>Owner</th>
                    <th style={financialDataItemTHStyle}>Amount</th>
                    <th style={financialDataItemTHStyle}>Tax Rate</th>
                    <th style={financialDataItemTHStyle}>Start Year</th>
                    <th style={financialDataItemTHStyle}>End Year</th>
                </tr>
            </thead>
            <tbody>
                {props?.incomes?.length > 0 && (
                    props.incomes.map((item, idx) => {
                        return <tr key={idx} style={financialDataItemTRStyle}>
                            <td style={financialDataItemTDStyle}>{displayIncomeTypeLabel(item)}</td>
                            <td style={financialDataItemTDStyle}>{item.frequency}</td>
                            <td style={financialDataItemTDStyle}>
                                {AppliesToFriendlyNames[item.appliesTo]}&nbsp;
                                {item.appliesTo === "TRUST" && <span>{item.trustName}</span>}
                            </td>
                            <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.amount)}</td>
                            <td style={financialDataItemTDStyle}>{`${item.tax.toFixed(0)}%`}</td>
                            <td style={financialDataItemTDStyle}>{item.startYear}</td>
                            <td style={financialDataItemTDStyle}>{item.endYear}</td>
                        </tr>
                    }))}
            </tbody>
        </table>
    </div>)

}

